import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { queryClient } from 'configs/queryClient';

async function storeAccount(apiClient: ApiClient, body: operations['createAccount']['requestBody']['content']['application/json']) {
  return apiClient.POST('/op/v2/account', { body });
}

export default function useStoreAccountMutation(workshopId: number) {
  const apiClient = useApiClient();

  return useMutation<InferFetchData<typeof storeAccount>, ApiError, operations['createAccount']['requestBody']['content']['application/json']>({
    mutationKey: ['StoreWorkshopAccount', workshopId],
    mutationFn: (body) => throwOnError(storeAccount(apiClient, body)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['WorkshopAccountsQuery', workshopId] });
    },
  });
}
